import { getWindowLocationOrigin } from '../../../utils/window'
import { generateMetaTags } from '../../../utils/helmet'

const title = 'Privacy Policy | IrisVR'
const description =
  "Learn about IrisVR's privacy policy relating to use of the company's software, including Prospect and Scope."
const url = `${getWindowLocationOrigin()}/privacy`
const image =
  'https://s3.amazonaws.com/iris-opengraph-images/ImgTag_Prospect2.jpg'
const imageWidth = 1200
const imageHeight = 630

export default generateMetaTags({
  title,
  description,
  image,
  url,
  imageWidth,
  imageHeight,
})
